import './naplesbayresort/style';
import FormStructure from './naplesbayresort/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js